/** Id prefix of assets generated by auto-detection and not yet confirmed (saved) by the user. */
export const AUTO_DETECT_ASSET_ID_PREFIX = 'temp-auto-detect-asset-';

/** True for a preview asset generated by auto-detection that has not been confirmed yet. */
export function isAutoDetectPreviewAsset(assetId: string | null | undefined): boolean {
  return !!assetId && assetId.startsWith(AUTO_DETECT_ASSET_ID_PREFIX);
}

export const DETECTION_CLASSES_SEPARATOR = ',';

/** Splits user-entered text (e.g. pasted "chair, table") into individual class names. */
export function parseDetectionClasses(text: string): string[] {
  return text
    .split(DETECTION_CLASSES_SEPARATOR)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

/**
 * Serializes class names into the `Classes` form field expected by `ObjectDetection/DetectAssets`.
 * Returns `undefined` when nothing meaningful was provided so the backend falls back to its default model.
 */
export function serializeDetectionClasses(classes: readonly string[]): string | undefined {
  const seen = new Set<string>();
  const unique: string[] = [];
  for (const entry of classes) {
    const trimmed = entry.trim();
    const key = trimmed.toLowerCase();
    if (!trimmed || seen.has(key)) continue;
    seen.add(key);
    unique.push(trimmed);
  }
  return unique.length ? unique.join(DETECTION_CLASSES_SEPARATOR) : undefined;
}
